import { TabButtonsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Component for tab buttons selectors.
 * Shows a navigation header.
 * The disable attribute can be used to disable the tab.
 * @example
 * ```html
 * <salaxy-tab-buttons active="active">
 * </salaxy-tab-buttons>
 * ```
 */
export class TabButtons extends ComponentBase   {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      currentTab: "=",
      options: "<",
      tabsId: "@",
      defaultTab: "<",
      // Updates the ?tab= parameter on tab change, causing a browser reload.
      updateTabParam: "<"
    };

    /** Uses the TabButtonsController */
    public controller = TabButtonsController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/TabButtons.html";
}